// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2vNX2","overflowing":"ReadFullNote_overflowing__2k6jJ"};